import { useApi } from './api.mjs';

/**
 * Returns the `Shop` where the checkout is taking place.
 */
function useShop() {
  return useApi().shop;
}

export { useShop };
